module.exports = __webpack_public_path__ + "img/tim.971e53a7.png";